import type { FeatureZoomOverride } from "./featureZoomOverrideTypes";

export function fireplaceFeatureZoomOverrides(partId: string): FeatureZoomOverride | undefined {
  switch (partId) {
    case "left_wall":
    case "right_wall":
    case "front_wall":
      return { scale: 1 };
    default:
      return undefined;
  }
}
